import { ChangeEvent } from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "utils/locales/utilityFunctions";
import CheckboxInputField from "components/input/checkboxInputField";

type RawWoodInputInformationChipStatusProps = {
  isChipped: boolean;
  averageLogLength: string;
  disabled: boolean;
  setIsChipped: (value: boolean) => void;
  setAverageLogLength: (event: ChangeEvent<HTMLInputElement>) => void;
};

const RawWoodInputInformationChipStatus = ({
  isChipped,
  averageLogLength,
  disabled,
  setIsChipped,
  setAverageLogLength,
}: RawWoodInputInformationChipStatusProps) => {
  const { translate } = useTranslation();
  const lengthLabel = translate(
    "input-dialog-raw-wood-tab-information-species-and-grading-length"
  );

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: -1, mt: -1 }}>
          {translate("input-dialog-raw-wood-tab-information-chip-status")}
        </Typography>
      </Grid>
      <CheckboxInputField
        label={translate(
          "input-dialog-raw-wood-tab-information-already-chipped"
        )}
        selected={isChipped}
        value={averageLogLength}
        inputTitle={lengthLabel}
        placeholder={lengthLabel}
        inputAdornment="m"
        disabled={disabled}
        showInputWhenChecked={false}
        onToggle={() => setIsChipped(!isChipped)}
        onValueChange={setAverageLogLength}
      />
    </>
  );
};

export default RawWoodInputInformationChipStatus;
